import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import MainLayout from "../../layout/MainLayout";
import axios from "axios";

const API_BASE = "https://globizsystems.click";
const getToken = () => localStorage.getItem("token") || localStorage.getItem("agent_token") || "";

const UpdateSewaCustomer = () => {
  const { bil } = useParams();
  const navigate = useNavigate();

  const [client, setClient] = useState(null);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");

  // Fetch by BIL (reuse existing lookup endpoint)
  // useEffect(() => {
  //   const fetchClient = async () => {
  //     try {
  //       setLoading(true);
  //       setError("");
  //       const resp = await qrLookup(bil);
  //       const record = resp?.record || resp?.data || resp?.result || resp?.customer || resp;

  //       if (!record) {
  //         setError("No record found.");
  //         return;
  //       }
  //       setClient(record);
  //     } catch (err) {
  //       console.error(err);
  //       setError("Failed to fetch Sewa Client data.");
  //     } finally {
  //       setLoading(false);
  //     }
  //   };

  //   if (bil) fetchClient();
  // }, [bil]);
// useEffect(() => {
//   const fetchClient = async () => {
//     try {
//       setLoading(true);
//       setError("");

//       const token = getToken();
//       if (!token) {
//         setError("Token missing. Please login again.");
//         return;
//       }

//       const res = await axios.post(
//         `${API_BASE}/api/agent/qr/lookup`,
//         { code: String(bil) },
//         { headers: { Authorization: `Bearer ${token}` } }
//       );

//       // backend returns record directly
//       setClient(res.data);
//     } catch (err) {
//       console.error(err);
//       setError(err?.response?.data?.error || "Failed to fetch Sewa Client data.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   if (bil) fetchClient();
// }, [bil]);
  const handleChange = (e) => {
    const { name, value } = e.target;
    setClient((prev) => ({ ...prev, [name]: value }));
  };
useEffect(() => {
  if (!bil) return;

  console.log("Fetching record for bil:", bil);

  const token = localStorage.getItem("token");
  if (!token) {
    console.log("No token found in localStorage");
    setError("Token missing. Please login again.");
    setLoading(false);
    return;
  }

  setLoading(true);
  setError("");

  axios
    .post(
      `${API_BASE}/api/agent/qr/lookup`,
      { code: String(bil) },
      { headers: { Authorization: `Bearer ${token}` } }
    )
    .then((res) => {
      console.log("Lookup response:", res.data);
      setClient(res.data);
    })
    .catch((err) => {
      console.error("Lookup error:", err);
      setError(err?.response?.data?.error || "Failed to fetch Sewa Client data.");
    })
    .finally(() => setLoading(false));
}, [bil]);



  const handleUpdate = async (e) => {
    e.preventDefault();
    setSaving(true);
    setError("");

    try {
      const token = getToken();
      await axios.patch(
        `${API_BASE}/api/agent/sewa/customer/${encodeURIComponent(bil)}`,
        {
          telefon: client?.telefon ?? "",
          email: client?.email ?? "",
          status: client?.status ?? "",
          kategori: client?.kategori ?? "",
        },
        {
          headers: token ? { Authorization: `Bearer ${token}` } : {},
        }
      );

      alert("Updated successfully!");
      navigate("/scanner");
    } catch (err) {
      console.error(err);
      setError(err?.response?.data?.error || "Failed to update data.");
    } finally {
      setSaving(false);
    }
  };

  if (loading)
    return (
      <MainLayout>
        <p className="text-gray-600 px-4 py-6">Loading Sewa Client data...</p>
      </MainLayout>
    );

  if (error)
    return (
      <MainLayout>
        <p className="text-red-600 px-4 py-6">{error}</p>
      </MainLayout>
    );

  if (!client)
    return (
      <MainLayout>
        <p className="px-4 py-6">No client found.</p>
      </MainLayout>
    );

  return (
    <MainLayout>
      <div className="max-w-3xl mx-auto bg-white shadow-md rounded-lg p-6 mt-6">
        <h2 className="text-2xl font-bold mb-4 text-gray-700">Edit Sewa Client</h2>

        <form onSubmit={handleUpdate} className="grid grid-cols-2 gap-4 text-sm">
          <div className="col-span-2">
            <label className="block text-gray-600">BIL</label>
            <input
              type="text"
              value={client.bil || bil || ""}
              readOnly
              className="border rounded-md w-full p-2 bg-gray-100"
            />
          </div>

          <div className="col-span-2">
            <label className="block text-gray-600">Nama Penyewa</label>
            <input
              type="text"
              value={client.nama_penyewa || client.namaPenyewa || ""}
              readOnly
              className="border rounded-md w-full p-2 bg-gray-100"
            />
          </div>

          <div>
            <label className="block text-gray-600">Telefon</label>
            <input
              type="text"
              name="telefon"
              value={client.telefon || ""}
              onChange={handleChange}
              className="border rounded-md w-full p-2"
            />
          </div>

          <div>
            <label className="block text-gray-600">Email</label>
            <input
              type="email"
              name="email"
              value={client.email || ""}
              onChange={handleChange}
              className="border rounded-md w-full p-2"
            />
          </div>

          <div>
            <label className="block text-gray-600">Status</label>
            <input
              type="text"
              name="status"
              value={client.status || ""}
              onChange={handleChange}
              className="border rounded-md w-full p-2"
              placeholder="(optional)"
            />
          </div>

          <div>
            <label className="block text-gray-600">Kategori</label>
            <input
              type="text"
              name="kategori"
              value={client.kategori || ""}
              onChange={handleChange}
              className="border rounded-md w-full p-2"
              placeholder="(optional)"
            />
          </div>

          <div className="col-span-2 flex justify-end mt-4 gap-2">
            <button
              type="button"
              className="bg-gray-200 text-gray-800 px-4 py-2 rounded-lg"
              onClick={() => navigate(-1)}
            >
              Back
            </button>

            <button
              type="submit"
              disabled={saving}
              className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 disabled:opacity-50"
            >
              {saving ? "Saving..." : "Update"}
            </button>
          </div>
        </form>
      </div>
    </MainLayout>
  );
};

export default UpdateSewaCustomer;